import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { searchOrderEvents } from "./api";
import { donationsKeys } from "./useDonationsListPage";
import type { OrderActivityResponse } from "./types";

interface UseOrderActivityArgs {
  orderId?: number | string;
  page: number;
  pageSize: number;
}

export const useOrderActivityQuery = ({
  orderId,
  page,
  pageSize,
}: UseOrderActivityArgs) =>
  useQuery<OrderActivityResponse>({
    queryKey: donationsKeys.activity({
      orderId: orderId ?? "",
      page,
      pageSize,
    }),
    queryFn: async () => {
      const response = await searchOrderEvents({
        orderId: orderId!,
        page,
        pageSize,
      });
      return response.data;
    },
    enabled: !!orderId,
    ...reactQueryCacheAndRefetchOptions,
  });
